module.exports = __webpack_public_path__ + "img/Mecanika-EteOhParc-2023.807b8be.jpg";